<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-5"></a>
<h1 class="tocheading">Contents</h1>
<div class="img_container2">
<img alt="Image" class="inline" src="images/img1.jpg"/>
</div>
<h2 class="toc_chap1"><a href="#/xhtml/05_Author">Author’s Biography</a></h2>
<h2 class="toc_chap"><a href="#/xhtml/06_Chapter_1"><span class="bold">Chapter One: </span>A Brief History of Folkestone and the Outbreak of War</a></h2>
<h2 class="toc_chap"><a href="#/xhtml/07_Chapter_2"><span class="bold">Chapter Two: </span>1914 – Starting Out</a></h2>
<h2 class="toc_chap"><span href="#/xhtml/08_Chapter_3" title="Link target outside of Sample"><span class="bold">Chapter Three: </span>1915 – Deepening Conflict</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/09_Chapter_4" title="Link target outside of Sample"><span class="bold">Chapter Four: </span>1916 – The Realisation</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/10_Chapter_5" title="Link target outside of Sample"><span class="bold">Chapter Five: </span>1917 – Seeing it through</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/11_Chapter_6" title="Link target outside of Sample"><span class="bold">Chapter Six: </span>1918 – The Final Push</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/12_Chapter_7" title="Link target outside of Sample"><span class="bold">Chapter Seven: </span>Folkestone War Memorial</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/13_Chapter_8" title="Link target outside of Sample"><span class="bold">Chapter Eight: </span>Folkestone Voluntary Aid Detachment</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/14_Chapter_9" title="Link target outside of Sample"><span class="bold">Chapter Nine: </span>Women in the War</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/15_Chapter_10" title="Link target outside of Sample"><span class="bold">Chapter Ten: </span>The aftermath of the war</span></h2>
<h2 class="toc_chap2"><span href="#/xhtml/16_Sources" title="Link target outside of Sample">Sources</span></h2>
<a id="VPS-6"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?8ef4ce48